import { useState } from 'react'

import { ToggleMultiCheckbox, combinedFields } from '@ana/shared'
import { useField } from 'formik'

const MedicationsItem: React.FC = () => {
  const [field, meta, helpers] = useField('medications')

  const [takesOtherMedications, setTakesOtherMedications] = useState(field.value ? field.value.length > 0 : false)

  const handleValuesChange = (values: string[]) => {
    helpers.setValue(values)
  }

  const handleToggleChange = (_: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setTakesOtherMedications(checked)
  }

  return (
    <ToggleMultiCheckbox
      label="field.do_you_regularly_take_any_other_medication"
      value={takesOtherMedications}
      options={combinedFields.medications.options}
      onSelectedValuesChange={handleValuesChange}
      onToggleChange={handleToggleChange}
      selectedValues={field.value}
      helperText={combinedFields.medications.helperText}
      allowCustomOptions
      error={meta.error}
    />
  )
}

export default MedicationsItem
